import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '../ui/dialog';

interface UnsavedChangesModalProps {
  open: boolean;
  onLeave: () => void;
  onStay: () => void;
}

export default function UnsavedChangesModal({ open, onLeave, onStay }: UnsavedChangesModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onStay(); }}>
      <DialogContent data-testid="unsaved-changes-modal" className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-[20px]">Unsaved changes</DialogTitle>
          <DialogDescription>
            You have unsaved changes to this activity. Leave without saving?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <button
            onClick={onLeave}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-danger text-pine-danger hover:bg-pine-danger hover:text-white transition-colors"
          >
            Leave without saving
          </button>
          <button
            onClick={onStay}
            className="px-4 py-2 text-sm font-semibold rounded-pine-input border-[1.5px] border-pine-pine text-pine-pine hover:bg-pine-hover-button transition-colors"
          >
            Stay
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
